var map = {
	"./101大樓.jpg": "26c4",
	"./roomImg.jpg": "5d42",
	"./spotImg.jpg": "4fec",
	"./九份.jpg": "316c",
	"./合歡山.jpg": "894f",
	"./太魯閣.jpg": "f13e",
	"./日月潭.jpg": "d3f1",
	"./清水斷崖.jpg": "f918",
	"./綠色隧道.jpg": "e805",
	"./美術館.jpg": "d1ee",
	"./野柳女王頭.jpg": "36fc",
	"./韭菜花田.jpg": "38d2",
	"./鼻頭角.jpg": "4822"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b5a1";